import axios from "axios";
import { TTP_API_URL } from "../config";
import { getRequestConfig, throwCatchedError } from "../utils";

export const getIdentitiesVerificationStatus = (token) => {
  const requestUrl = `${TTP_API_URL}/mailing/registered-mails`;
  const params = {
    access_token: token,
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const registerEmail = (token, email) => {
  const requestUrl = `${TTP_API_URL}/mailing/verify-email`;
  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};
const LAMBDA_URL =
  "https://hxqwl6tnv75s2sywhrvqa4ooqa0rbwrm.lambda-url.eu-west-1.on.aws/";
const API_KEY = "lkC/pLBuOi6SDhni+MojjGE2y1g7DOH2rA3S+opPEKU=";

const makeSESRequest = async (type, value) => {
  try {
    const res = await fetch(LAMBDA_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": API_KEY,
      },
      body: JSON.stringify({
        type,
        value,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "SES verification error");
    }

    return data;
  } catch (error) {
    console.error("SES API Error:", error);
    throw error;
  }
};
export const registerDomainSES = (domain) => {
  return makeSESRequest("verify", domain);
};

export const checkDomainSES = (domain) => {
  return makeSESRequest("domain", domain);
};
